// extracted by mini-css-extract-plugin
export var statisticsItem = "Statistics-module--statisticsItem--14A7k";